angular.module("app").controller("HomePageController", [
    '$scope',
    'userStorage',
    function ($scope, userStorage) {
        $scope.user = userStorage.getUserData();
        $scope.menu_switcher = false;

        $scope.closeMain = function () {
            $scope.menu_switcher = true;
        }

    }
]);